import React, { Component } from 'react';
import { AppContext } from './../AppContext';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import logo from './img/svg/Logosistema.svg';

const ColoredLine = ({ color }) => (
    <hr
        style={{
            color: color,
            backgroundColor: color,
            height: 2
        }}
    />
);

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
    }

  render() {
    const currentUser = this.context;
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow mb-3" light>
                <Container>
                    <NavbarBrand tag={Link} to="/"><img src={logo} width="360px" height="40px" alt="Logo" /></NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow"> 
                {/*<NavItem>*/}
                {/*<NavLink tag={Link} className="text-dark" to="/validacion">Carga Academica</NavLink>*/}
                {/*</NavItem> */}
                <NavItem>
                    {currentUser && currentUser.idpersona > 0 ? 
                                    <div className="nombreUsuario">{currentUser.nombres + " " + currentUser.apellidos}</div>
                    : 
                    <></>
                    }
                </NavItem>
              </ul>
            </Collapse>
                </Container>
            </Navbar>

            <ColoredLine color="#010453" />
        </header>
        
    );
  }
}
NavMenu.contextType = AppContext;